import { Backdrop, CircularProgress } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetSingleByIdTranscationQuery } from "src/services/transcationService";
import { LOGIN_PAGE_LOGO } from "src/utils/constants";

const tableHead = 'border-r border-slate-900 py-1 '
const tableCell = 'border-r border-slate-900 p-[5px] text-center'

const ReceiptComponent = () => {
    const { id } = useParams()
    const [receiptData, setReceiptData] = useState<any>()
    // **** Services
    const { data, isFetching, isLoading } = useGetSingleByIdTranscationQuery(id);

    // **** Use Effect for RECEIPT
    useEffect(() => {
        if (!isFetching && !isLoading) {
            setReceiptData(data?.data)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFetching, isLoading, data]);

    if (isFetching || isLoading) {
        return (
            <Backdrop open={true}>
                <CircularProgress />
            </Backdrop>
        );
    }

    return (
        <>
            <div className='bg-slate-500   h-[100vh]'>
                <div className="bg-white   h-[100vh] mx-auto my-auto  text-[14px]">
                    <div className=" border border-black ">
                        <div className="border-b border-black px-2">
                            <div className="flex justify-between">
                                <div className="w-96">
                                    <img src={LOGIN_PAGE_LOGO} className="h-20  w-half" alt="logo" />
                                </div>
                                <div className="flex ">
                                    <p className='  '> Order No:  {receiptData?.orderNumber || '-'}</p>
                                    <p className="">
                                        Subject To Indore Jurisdiction Commerce Billing B-1,Block-
                                        C, 2nd Floor, Navlakha Square, B.C.M City, Navlakha Madhya
                                        Pradesh, 452001, India State Code GSTIN 4398573987, PAN
                                        375347854593
                                    </p>

                                </div>
                            </div>
                            <div className="flex justify-between my-2">
                                <p>Order No: {receiptData?.orderNumber || '-'} </p>
                                <div className="flex gap-2">Date & Time:
                                    <p>
                                        {moment(receiptData?.createdAt).format("DD-MM-YYYY") || '-'}
                                    </p>
                                    <p>
                                        {moment(receiptData?.createdAt).format("hh:mm A") || '-'}
                                    </p>
                                </div>

                            </div>
                        </div>
                        <div className="grid grid-flow-col grid-cols-12 gap-10 px-2 border-b border-slate-900 ">
                            <p className="col-span-6  py-3 ">
                                <p className=" font-extrabold text-[16px]">Student Information -</p>
                                <div className="flex gap-20 mt-2">
                                    <p className="font-bold">Name:</p>
                                    <p className=" "> {receiptData?.order?.[0]?.name || '-'}</p>
                                </div>
                                <div className="flex gap-10 mt-2">
                                    <p className="font-bold">Mobile Number:</p>
                                    <p className=" "> {receiptData?.order?.[0]?.mobile || '-'}</p>
                                </div>
                                <div className="flex gap-10 mt-2">
                                    <p className="font-bold">Email:</p>
                                    <p className=" "> {receiptData?.order?.[0]?.email || '-'}</p>
                                </div>

                            </p>
                            <div className=" col-span-5 pt-1 pb-5 border-l   pl-3 border-slate-900">
                                <p className="font-extrabold text-[16px]">Delivery Address
                                </p>
                                <p className="mt-2">
                                    {receiptData?.order?.[0]?.address || '-'}</p>
                            </div>
                        </div>


                        <table width='100%' >
                            <tbody>
                                <tr className='border-b border-black'>
                                    <td className='w-1/3 py-2 pl-2'>Course - Level</td>
                                    <td className='border-l border-black pl-2 capitalize'>{receiptData?.order?.[0]?.courseName || '-'}</td>
                                </tr>
                                <tr className='border-b border-black'>
                                    <td className='w-1/3 py-2 pl-2'>Course Type</td>
                                    <td className='border-l border-black pl-2 capitalize'>{receiptData?.order?.[0]?.courseTypeName || '-'}</td>
                                </tr>
                                <tr className='border-b border-black'>
                                    <td className='w-1/3 py-2 pl-2'>Mode Name</td>
                                    <td className='border-l border-black pl-2 capitalize'>{receiptData?.order?.[0]?.modeName || '-'}</td>
                                </tr>
                                <tr className='border-b border-black'>
                                    <td className='w-1/3 py-2 pl-2'>Attempt  Name</td>
                                    <td className='border-l border-black pl-2 capitalize'>{receiptData?.order?.[0]?.attemptName || '-'}</td>
                                </tr>
                                <tr className='border-b border-black'>
                                    <td className='w-1/3 py-2 pl-2'>Faculties</td>
                                    <td className='border-l border-black pl-2 capitalize'>{receiptData?.order?.[0]?.faculties?.map((membership: any) => membership?.facultyName || "-")?.join(", ") || '-'}</td>
                                </tr><tr className='border-b border-black'>
                                    <td className='w-1/3 py-2 pl-2 '>Subjects</td>
                                    <td className='border-l border-black pl-2 capitalize'>{receiptData?.order?.[0]?.subjects?.map((membership: any) => membership?.subjectName || "-")?.join(", ") || '-'}</td>
                                </tr>
                                <tr className='border-b border-black'>
                                    <td className='w-1/3 py-2 pl-2'>Books</td>
                                    <td className='border-l border-black pl-2 capitalize'>{receiptData?.order?.[0]?.bookIssued?.map((membership: any) => membership?.bookName || "-")?.join(", ") || '-'}</td>
                                </tr>
                                <tr className='border-b border-black'>
                                    <td className='w-1/3 py-2 pl-2'>Delivery Mode</td>
                                    <td className='border-l border-black pl-2 capitalize'>{receiptData?.order?.[0]?.delivery || '-'}</td>
                                </tr>
                            </tbody>
                        </table>


                        <table width='100%' className='mt-5 border-t border-black'>
                            <thead>
                                <tr className=' border-black font-normal'>
                                    <th className={tableHead}>Total Fees</th>
                                    <th className={tableHead}>Amount Paid </th>
                                    <th className={`${tableHead}`}>Fee Paid Till Now</th>
                                    <th className={tableHead}>Remaining</th>
                                    <th className={`${tableHead}`}>Adjust Amount</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr className='border-y border-black font-normal'>
                                    <td className={tableCell}>{receiptData?.order?.[0]?.totalFees || '-'}</td>
                                    <td className={tableCell}>{receiptData?.actualAmount || '-'} </td>
                                    <td className={tableCell}>{receiptData?.order?.[0]?.feePaidTillNow || '-'}</td>
                                    <td className={tableCell}>{receiptData?.dueAmount || '-'}</td>
                                    <td className={tableCell}>{receiptData?.adjustAmount || '-'}</td>
                                </tr>
                            </tbody>

                        </table>


                        <div className="flex justify-between  mt-10 mb-20 px">
                            <p className="font-semibold text-[12px] w-1/2">This Is System Generated Receipt/Invoice
                                Hence No Signature Or Stamp Is Required</p>
                            <p className="text-[14px]0">Autorized Signatory</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReceiptComponent;
